<template>
    <ThePage class="container">
        <template v-slot:title>
            Продукция
            <a target="_blank" :href="getKBLink('products')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <div class="d-flex flex-column flex-lg-row justify-content-between mb-4">
            <div class="order-1 btn-group mb-3 mb-lg-0" role="group">
                <router-link :to="{ name: 'stocks.planograms' }" class="btn btn-outline-primary px-1 px-lg-4" :class="{ active: routeName === 'stocks.planograms' }">Планограммы</router-link>
                <router-link :to="{ name: 'stocks.products' }" class="btn btn-outline-primary px-1 px-lg-4" :class="{ active: routeName === 'stocks.products' }">Продукты</router-link>
                <router-link v-feature="'loading'" :to="{ name: 'stocks.recipes' }" class="btn btn-outline-primary px-1 px-lg-4" :class="{ active: routeName === 'stocks.recipes' }">Рецепты</router-link>
                <router-link v-feature="'loading'" :to="{ name: 'stocks.components' }" class="btn btn-outline-primary px-1 px-lg-4" :class="{ active: routeName === 'stocks.components' }">Ингредиенты</router-link>
            </div>

            <div class="order-3 order-lg-2 mt-3 mt-lg-0" v-if="hasGtin && routeName === 'stocks.products'">
                <div class="custom-control custom-checkbox mb-3 mb-xl-0">
                    <input id="gtin" v-model="showGtin" type="checkbox" class="custom-control-input">
                    <label class="custom-control-label" for="gtin">Отобразить GTIN</label>
                </div>
            </div>

            <router-link :to="createLinkTo" class="order-2 order-lg-3 btn btn-primary">Создать</router-link>
        </div>

        <div class="card mb-3 d-none d-sm-block">
            <div class="card-body card-body-search">
                <input v-focus :value="filter.search" type="text" class="form-control form-control-search" placeholder="Начните вводить название" @input="search">
            </div>
        </div>

        <router-view />
    </ThePage>
</template>

<script>
import debounce from 'lodash/debounce'
import store from '@/store'
import { fetchVats } from '@/components/SelectVat'
import ThePage from '@/components/ThePage'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        ThePage
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        showGtin: {
            get() {
                return this.$store.getters['stocks/gtinIsVisible']
            },

            set(value) {
                this.$store.dispatch('stocks/toggleGtin', value)
            }
        },

        createLinkTo() {
            return { name: `${this.routeName}.new` }
        },

        routeName() {
            return this.$route.name.replace('.new', '')
        },

        hasLoading() {
            return this.$store.getters['company/hasLoading']
        },

        hasGtin() {
            return this.$store.getters['company/hasGtin']
        }
    },

    methods: {
        search: debounce(function (e) {
            this.applyFilter({ page: 1, search: e.target.value })
        }, 300),

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        await Promise.all([
            store.dispatch('components/fetchAll'),
            fetchVats()
        ])

        next()
    }
}
</script>
